import styled, { css } from 'styled-components';

import ActionButton from 'components/action-button';
import UnstyledButton from 'components/unstyled-button';

export const StyledButtonBox = styled.div`
  display: inline-flex;
`;

export const StyledRecentOrderCard = styled.div`
  border-bottom: 1px solid #dcdcdc;
  display: flex;
  justify-content: space-between;
  padding: 1.25rem 1rem;
  background-color: ${Styles.color.cardBackground};
`;

export const StyledActionButton = styled(ActionButton)`
  font-size: 0.75rem;
  line-height: 1.25rem;
  color: ${Styles.color.primary};
`;

export const IconButton = styled(UnstyledButton)<{ disabled?: boolean }>`
  display: flex;

  ${p =>
    p.disabled &&
    css`
      color: #777777;
      pointer-events: none;
      cursor: default;

      path {
        fill: ${Styles.color.grey.nine};
      }
    `}
  svg {
    width: 20px;
    height: 20px;
  }
`;

export const fill = '';
